<template>
    <v-container fluid class="root-step-container">
        <h2 class="text-h5 mb-4">{{ $t("risk-aversion.form3.title") }}</h2>
        <EqsRadio
            :value.sync="formData.p3q1"
            row
            v-bind="{
                label: $t('risk-aversion.form3.q1-label'),
                ...schemaDouble.p3q1
            }"
        />
        <EqsRadio
            :value.sync="formData.p3q2"
            row
            v-bind="{
                label: $t('risk-aversion.form3.q2-label'),
                ...schemaDouble.p3q2
            }"
        />
        <EqsRadio
            :value.sync="formData.p3q3"
            row
            v-bind="{
                label: $t('risk-aversion.form3.q3-label'),
                ...schemaDouble.p3q3
            }"
        />
        <EqsRadio
            :value.sync="formData.p3q4"
            row
            v-bind="{
                label: $t('risk-aversion.form3.q4-label'),
                ...schemaDouble.p3q4
            }"
        />
        <EqsRadio
            :value.sync="formData.p3q5"
            row
            v-bind="{
                label: $t('risk-aversion.form3.q5-label'),
                ...schemaDouble.p3q5
            }"
        />
        <EqsRadio
            :value.sync="formData.p3q6"
            row
            v-bind="{
                label: $t('risk-aversion.form3.q6-label'),
                ...schemaDouble.p3q6
            }"
        />
        <EqsRadio
            :value.sync="formData.p3q7"
            row
            v-bind="{
                label: $t('risk-aversion.form3.q7-label'),
                ...schemaDouble.p3q7
            }"
        />
        <EqsRadio
            :value.sync="formData.p3q8"
            row
            v-bind="{
                label: $t('risk-aversion.form3.q8-label'),
                ...schemaDouble.p3q8
            }"
        />
        <EqsRadio
            :value.sync="formData.p3q9"
            row
            v-bind="{
                label: $t('risk-aversion.form3.q9-label'),
                ...schemaDouble.p3q9
            }"
        />
    </v-container>
</template>

<script>
import { formMixin } from "@equisafe-ui-vue/src/mixins/formMixin";

export default {
    name: "Form3",
    mixins: [formMixin],
    props: {
        loading: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped></style>
